import debugFactory from 'debug';
import Raven from 'raven-js';

const debug = debugFactory('sentry');

export default ({ sentryPublicDsn }) => {
  // noinspection JSUnresolvedVariable
  const appVersion = APP_VERSION; // eslint-disable-line no-undef

  if (sentryPublicDsn && !Raven.isSetup()) {
    Raven.config(sentryPublicDsn, {
      release: appVersion,
    }).install();
    debug('Sentry configured');
  } else {
    debug('Sentry not configured : config URL is empty');
  }
};



// WEBPACK FOOTER //
// ./shared/src/utils/initSentry.js